var _path, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 41,
    viewBox: "0 0 53 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6028 38.9706L10.7741 29.0096C9.98289 28.3433 10.6001 27.0612 11.6143 27.2641L26.0831 30.1578C26.7019 30.2816 27.2792 29.8083 27.2792 29.1773V15.4242C27.2792 14.5699 28.2814 14.109 28.93 14.665L37.3535 21.8851C37.8022 22.2697 38.4847 22.1834 38.8235 21.6993L47.2835 9.61361C47.8442 8.81264 49.1028 9.20936 49.1028 10.1871V29.6177",
    stroke: "#CC6152",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.33824,
    cy: 24.1618,
    r: 2.33824,
    fill: "#CC6152"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.721,
    cy: 5.45588,
    r: 2.33824,
    fill: "#CC6152"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.6615,
    cy: 2.33824,
    r: 2.33824,
    fill: "#CC6152"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKing);
export default __webpack_public_path__ + "static/media/king.0ca21726a8a3d9176bad7941a9e9d474.svg";
export { ForwardRef as ReactComponent };